import React from "react";

import { Stack, Typography } from "@mui/material";

// Logo display dimensions by size tier. 4:3 aspect ratio
// Used to ensure visual consistency across screens and breakpoints.
const logoDimensions = {
  sm: { width: 64, height: 48 },
  md: { width: 96, height: 72 },
  lg: { width: 120, height: 90 },
  xl: { width: 168, height: 126 },
  xxl: { width: 240, height: 180 },
};

const HEADER_HEIGHT = 190;

interface RestaurantHeaderProps {
  logoImageUrl?: string;
  brandName?: string;
  logoSize?: "sm" | "md" | "lg" | "xl" | "xxl";
}

export const RestaurantHeader = ({
  logoImageUrl,
  brandName,
  logoSize = "lg",
}: RestaurantHeaderProps) => {
  const { width, height } = logoDimensions[logoSize];

  return (
    <Stack alignItems={"center"}>
      {logoImageUrl ? (
        <img
          src={logoImageUrl}
          alt={brandName}
          width={width}
          height={height}
          style={{ objectFit: "contain" }} // Maintain logo integrity while fitting to fixed box size
        />
      ) : (
        // Fallback: show the brand name if no logo is provided
        <Typography variant={"h3"}>{brandName}</Typography>
      )}
    </Stack>
  );
};
